(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chiipop-detail-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chiipop-product-guide')) {
    customElements.define('chiipop-product-guide', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-cp-guide-close]');
          if (!button || button.closest('chiipop-product-guide') !== this) return;
          const details = button.closest('details');
          details.open = false;
          const nav = document.querySelector('chiipop-sticky-nav');
          if (nav?.jump) nav.jump(details, false);
          else details.scrollIntoView({ block: 'start' });
          details.querySelector('summary').focus({ preventScroll: true });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiipop-sticky-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chiipop-sticky-nav')) {
    customElements.define('chiipop-sticky-nav', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.wrapper = this.closest('.shopify-section');
        this.track = this.querySelector('.cp-nav__links');
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.headerTransitions = new Set();
        this.settle = () => {
          clearTimeout(this.jumpTimer);
          if (this.jumpTarget) this.jumpTimer = setTimeout(() => this.finishJump(), 160);
        };
        this.update = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const line = this.offset() + 24;
            let active = null;
            for (const item of this.items) {
              if (!item.target.getClientRects().length) continue;
              if (!active || item.target.getBoundingClientRect().top <= line) active = item;
            }
            if (active?.link !== this.active) {
              this.active?.removeAttribute('aria-current');
              this.active = active?.link;
              if (this.active) {
                this.active.setAttribute('aria-current', 'location');
                const linkBox = this.active.getBoundingClientRect();
                const trackBox = this.track.getBoundingClientRect();
                this.track.scrollBy({ left: linkBox.left - trackBox.left - (trackBox.width - linkBox.width) / 2, behavior: 'instant' });
              }
            }
            if (this.headerTransitions.size) this.update();
          });
        };
        this.refresh = () => {
          this.items = [];
          this.targets = new Map();
          for (const link of this.links) {
            const target = document.getElementById(link.dataset.target);
            this.targets.set(link, target);
            const valid = target && !this.wrapper.contains(target);
            link.hidden = !valid && this.dataset.designMode !== 'true';
            link.removeAttribute('aria-current');
            if (valid) this.items.push({ link, target });
          }
          this.items.sort((a, b) => a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
          this.hidden = !this.items.length && this.dataset.designMode !== 'true';
          this.wrapper.style.borderStyle = this.hidden ? 'none' : '';
          this.active = null;
          this.findHeaders();
          this.update();
        };
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-target]');
          if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const item = this.items.find(item => item.link === link);
          if (!item) return;
          event.preventDefault();
          history.pushState(null, '', '#' + encodeURIComponent(link.dataset.target));
          this.jump(item.target, true);
        }, { signal });
        this.restore = () => {
          let id;
          try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
          const item = this.items.find(item => item.target.id === id);
          if (item) this.jump(item.target, false);
        };
        window.addEventListener('scroll', () => { this.update(); this.settle(); }, { passive: true, signal });
        window.addEventListener('scrollend', () => this.finishJump(), { signal });
        for (const event of ['wheel', 'touchstart', 'keydown']) {
          window.addEventListener(event, () => { this.jumpTarget = null; clearTimeout(this.jumpTimer); }, { passive: true, signal });
        }
        window.addEventListener('resize', this.update, { passive: true, signal });
        window.addEventListener('hashchange', this.restore, { signal });
        window.addEventListener('popstate', this.restore, { signal });
        window.addEventListener('load', this.restore, { once: true, signal });
        const headerTransition = event => {
          const index = this.headers.indexOf(event.target);
          if (index < 0) return;
          const key = `${index}:${event.propertyName}`;
          if (event.type === 'transitionrun') this.headerTransitions.add(key);
          else this.headerTransitions.delete(key);
          this.update();
          this.settle();
        };
        for (const event of ['transitionrun', 'transitionend', 'transitioncancel']) {
          document.addEventListener(event, headerTransition, { capture: true, signal });
        }
        for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
          document.addEventListener(event, this.refresh, { signal });
        }
        this.addEventListener('shopify:block:select', event => {
          const link = event.target.closest('a[data-target]');
          const item = this.items.find(item => item.link === link);
          if (item) this.jump(item.target, false);
        }, { signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.wrapper);
        this.headerObserver = new MutationObserver(this.update);
        this.headerResize = new ResizeObserver(this.update);
        this.mutations = new MutationObserver(records => {
          if (records.some(record => record.target === this.wrapper.parentElement)
            || this.links.some(link => document.getElementById(link.dataset.target) !== this.targets.get(link))) this.refresh();
        });
        this.mutations.observe(this.wrapper.parentElement, { childList: true, subtree: true });
        this.refresh();
        if (document.readyState === 'complete') this.restore();
      }
      findHeaders() {
        const previous = this.headers || [];
        this.headerObserver.disconnect();
        this.headerResize.disconnect();
        try {
          this.headers = this.dataset.autoHeader === 'true'
            ? [...document.querySelectorAll(this.dataset.headerSelector)].filter(element => !this.wrapper.contains(element))
            : [];
        } catch { this.headers = []; }
        if (previous.length !== this.headers.length || previous.some((header, index) => header !== this.headers[index])) this.headerTransitions.clear();
        for (const header of this.headers) {
          this.headerObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
          this.headerResize.observe(header);
        }
      }
      offset(reserveHeader = false) {
        const height = this.wrapper.offsetHeight;
        let top = 0;
        let fullTop = 0;
        if (this.headers.length) {
          for (const header of this.headers) {
            const style = getComputedStyle(header);
            if (!['sticky', 'fixed'].includes(style.position) || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
            const rect = header.getBoundingClientRect();
            if (!rect.width || !rect.height || rect.left >= innerWidth || rect.right <= 0) continue;
            top = Math.max(top, rect.bottom);
            fullTop = Math.max(fullTop, rect.bottom, rect.height);
          }
          top = Math.max(0, Math.min(innerHeight, top));
          if (this.autoTop !== top) {
            this.wrapper.style.setProperty('--cp-nav-auto-top', `${top}px`);
            this.autoTop = top;
          }
        } else {
          if (this.autoTop !== undefined) {
            this.wrapper.style.removeProperty('--cp-nav-auto-top');
            this.autoTop = undefined;
          }
          top = parseFloat(getComputedStyle(this.wrapper).top) || 0;
          fullTop = top;
        }
        return (reserveHeader ? Math.max(top, fullTop) : top) + height;
      }
      jump(target, smooth) {
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabindex) target.removeAttribute('tabindex');
        const targetTop = target.getBoundingClientRect().top;
        const goingUp = targetTop < this.offset() + 16;
        this.jumpTarget = target;
        this.jumpCorrections = 0;
        window.scrollTo({
          top: window.scrollY + targetTop - this.offset(goingUp) - 16,
          behavior: smooth && this.dataset.smooth === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
        });
        this.update();
        this.settle();
      }
      finishJump() {
        if (!this.jumpTarget?.isConnected) { this.jumpTarget = null; return; }
        if (this.headerTransitions.size) { this.settle(); return; }
        const delta = this.jumpTarget.getBoundingClientRect().top - this.offset() - 16;
        if (Math.abs(delta) < 1 || this.jumpCorrections >= 3) { this.jumpTarget = null; return; }
        this.jumpCorrections++;
        window.scrollBy({ top: delta, behavior: 'instant' });
        this.settle();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.mutations?.disconnect();
        this.headerObserver?.disconnect();
        this.headerResize?.disconnect();
        this.headerTransitions?.clear();
        clearTimeout(this.jumpTimer);
        this.jumpTarget = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.autoTop = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chillpop-sticky-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chillpop-details')) {
    customElements.define('chillpop-details', class extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.cp-details__nav');
        if (!this.nav || this.controller) return;
        this.links = [...this.querySelectorAll('.cp-details__link')];
        this.panels = this.links.map(link => document.getElementById(link.hash.slice(1)));
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.update = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const top = parseFloat(getComputedStyle(this.nav).top) || 0;
            const line = top + this.nav.offsetHeight + 24;
            let active = 0;
            this.panels.forEach((panel, index) => {
              if (panel.getBoundingClientRect().top <= line) active = index;
            });
            this.links.forEach((link, index) => {
              if (index === active) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            });
          });
        };
        this.nav.addEventListener('click', event => {
          const link = event.target.closest('.cp-details__link');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          const target = this.panels[this.links.indexOf(link)];
          if (!target) return;
          event.preventDefault();
          target.focus({ preventScroll: true });
          const top = parseFloat(getComputedStyle(this.nav).top) || 0;
          window.scrollTo({
            top: window.scrollY + target.getBoundingClientRect().top - top - this.nav.offsetHeight - 16,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal });
        window.addEventListener('scroll', this.update, { passive: true, signal });
        window.addEventListener('resize', this.update, { passive: true, signal });
        this.observer = new ResizeObserver(() => {
          this.style.setProperty('--cp-nav-height', `${this.nav.offsetHeight}px`);
          this.update();
        });
        this.observer.observe(this.nav);
        this.observer.observe(this.querySelector('.cp-details__body'));
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('.cp-details__panel');
          if (panel) panel.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal });
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
